import { FormGroup, ValidationErrors, AbstractControl } from '@angular/forms';

/**
 * Rozhraní pro popis chyby ve formuláři.
 */
export interface IFormError {
  // Název ovládacího prvku, ve kterém se chyba nachází.
  control: string;

  // Klíč chyby, který popisuje typ chyby.
  error: string;

  // Hodnota spojená s chybou (např. očekávaná hodnota nebo další informace o chybě).
  value: any;
}

/**
 * Funkce pro získání všech validačních chyb z formuláře (FormGroup).
 *
 * Tato funkce prochází všechny ovládací prvky (FormControl) a vnořené skupiny (FormGroup)
 * ve formuláři a vrací seznam všech nalezených chyb.
 *
 * @param {FormGroup} form - Formulář (FormGroup), ze kterého se mají získat chyby.
 * @returns {IFormError[]} Pole objektů popisujících chyby ve formuláři.
 */
export function getFormValidationErrors(form: FormGroup): IFormError[] {
  const result: IFormError[] = [];

  // Získání chyb přímo z FormGroup
  const formErrors: ValidationErrors | null = form.errors;
  if (formErrors) {
    Object.keys(formErrors).forEach((keyError) => {
      result.push({
        control: '(formGroup)', // Označení, že chyba pochází z FormGroup
        error: keyError,
        value: formErrors[keyError],
      });
    });
  }

  // Získání chyb z jednotlivých FormControl a vnořených FormGroup
  Object.keys(form.controls).forEach((key) => {
    const formProperty: AbstractControl | null = form.get(key);

    // Pokud je ovládací prvek typu FormGroup, rekurzivně získáme jeho chyby
    if (formProperty instanceof FormGroup) {
      result.push(...getFormValidationErrors(formProperty));
    }

    // Získání chyb z aktuálního ovládacího prvku
    const controlErrors: ValidationErrors | null = formProperty?.errors || null;

    if (controlErrors) {
      Object.keys(controlErrors).forEach((keyError) => {
        result.push({
          control: key, // Název ovládacího prvku
          error: keyError, // Klíč chyby
          value: controlErrors[keyError], // Hodnota chyby
        });
      });
    }
  });

  return result;
}
